import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Hero from '@/components/sections/Hero';
import LogoMarquee from '@/components/sections/LogoMarquee';
import FeaturedWork from '@/components/sections/FeaturedWork';
import ServicesSection from '@/components/sections/ServicesSection';
import WhyTechsFlow from '@/components/sections/WhyTechsFlow';
import Testimonials from '@/components/sections/Testimonials';
import FinalCTA from '@/components/sections/FinalCTA';
import ProcessSection from "@/components/sections/ProcessSection";
import Industries from "../components/sections/Industries";

export default function Home() {
  return (
    <motion.main
      id="main-content"
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Helmet>
        <title>Home | TechsFlow</title>
      </Helmet>
      <Hero />
      <LogoMarquee />
      <Industries/>
      <ServicesSection />
      <WhyTechsFlow />
      {/*<ProcessSection/>*/}
      <FeaturedWork />
      <Testimonials />
      <FinalCTA />
    </motion.main>
  );
}
